import React from 'react'

import { useLocation, useHistory } from 'react-router-dom'

import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Paper,
  Box,
  Divider,
  makeStyles,
} from '@material-ui/core'

import { Container, ContentHeader } from 'components'
import Steps from './components/Steps'
import ClientContext from 'contexts/ClientContext'
import { routes } from 'routes'

const useStyles = makeStyles(theme => ({
  root: {
    width: '90%',
  },
  stepper: {
    padding: theme.spacing(3, 1),
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    overflow: 'hidden',
  },
  overflow: {
    overflow: 'hidden',
  },
}))

const ClientsNew = () => {
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()

  const { activeStep, formId, backStep, nextStep } = React.useContext(
    ClientContext,
  )

  const handleClickBackButton = () => {
    if (location?.state?.fromContractsNew && activeStep === 0) {
      history.push({
        pathname: routes.contracts.new,
        state: {
          ...location.state,
        },
      })

      return
    }
    if (location?.state?.from && activeStep === 0) {
      history.push({
        pathname: location.state.from,
        state: {
          ...location.state,
        },
      })

      return
    }

    backStep()
  }

  const handleClickNextButton = () => {
    if (activeStep === 3) {
      nextStep()
    }
  }

  return (
    <Container>
      <ContentHeader title="Cliente" subtitle="Novo" />
      <Paper className={classes.overflow}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          <Step>
            <StepLabel>Tipo de Pessoa</StepLabel>
          </Step>
          <Step>
            <StepLabel>Dados do Cliente</StepLabel>
          </Step>
          <Step>
            <StepLabel>Endereço</StepLabel>
          </Step>
          <Step>
            <StepLabel>Revisão e Finalização</StepLabel>
          </Step>
        </Stepper>
        <Divider />
        <Box p={2}>
          {activeStep === 0 && <Steps.Type />}
          {activeStep === 1 && <Steps.Data />}
          {activeStep === 2 && <Steps.Address />}
          {activeStep === 3 && <Steps.Summary />}
          {activeStep === 4 && <Steps.Finish />}
        </Box>
        {activeStep < 4 && (
          <div>
            <Divider />
            <Box display="flex" justifyContent="space-between" px={2} py={2}>
              <Button
                variant="outlined"
                color="primary"
                disabled={
                  !(
                    activeStep !== 0 ||
                    location?.state?.fromContractsNew ||
                    location?.state?.from
                  )
                }
                onClick={handleClickBackButton}
                className={classes.button}
              >
                Voltar
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                form={formId}
                onClick={handleClickNextButton}
                type="submit"
              >
                {activeStep === 3 ? 'Cadastrar' : 'Continuar'}
              </Button>
            </Box>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default ClientsNew
